// Author Lin
// Date 2021-11-20 14:52:35

class MintalMesPrdSmeltingFurnaceMeasure {
        constructor({
                id = null,
                measureTime = '',
                locationId = '',
                locationName = '',
                shiftId = '',
                shiftName = '',
                furnaceId = '',
                furnaceName = '',
                rise1 = '',
                offset1 = '',
                rise2 = '',
                offset2 = '',
                rise3 = '',
                offset3 = '',
                rise4 = '',
                offset4 = '',
                rise5 = '',
                offset5 = '',
                rise6 = '',
                offset6 = '',
                rise7 = '',
                offset7 = '',
                rise8 = '',
                offset8 = '',
                rise9 = '',
                offset9 = '',
                rise10 = '',
                offset10 = '',
                rise11 = '',
                offset11 = '',
                rise12 = '',
                offset12 = '',
                recorderId = '',
                recorder = '',
                reviewerId = '',
                reviewer = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.measureTime = measureTime;
            this.locationId = locationId;
            this.locationName = locationName;
            this.shiftId = shiftId;
            this.shiftName = shiftName;
            this.furnaceId = furnaceId;
            this.furnaceName = furnaceName;
            this.rise1 = rise1;
            this.offset1 = offset1;
            this.rise2 = rise2;
            this.offset2 = offset2;
            this.rise3 = rise3;
            this.offset3 = offset3;
            this.rise4 = rise4;
            this.offset4 = offset4;
            this.rise5 = rise5;
            this.offset5 = offset5;
            this.rise6 = rise6;
            this.offset6 = offset6;
            this.rise7 = rise7;
            this.offset7 = offset7;
            this.rise8 = rise8;
            this.offset8 = offset8;
            this.rise9 = rise9;
            this.offset9 = offset9;
            this.rise10 = rise10;
            this.offset10 = offset10;
            this.rise11 = rise11;
            this.offset11 = offset11;
            this.rise12 = rise12;
            this.offset12 = offset12;
            this.recorderId = recorderId;
            this.recorder = recorder;
            this.reviewerId = reviewerId;
            this.reviewer = reviewer;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdSmeltingFurnaceMeasure();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'measureTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.measureTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'shiftName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.shiftName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.furnaceName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'rise1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.rise1',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'offset1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.offset1',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'rise2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.rise2',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'offset2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.offset2',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'rise3',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.rise3',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'offset3',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.offset3',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'rise4',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.rise4',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'offset4',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.offset4',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'rise5',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.rise5',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'offset5',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.offset5',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'rise6',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.rise6',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'offset6',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.offset6',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'rise7',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.rise7',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'offset7',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.offset7',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'rise8',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.rise8',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'offset8',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.offset8',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'rise9',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.rise9',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'offset9',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.offset9',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'rise10',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.rise10',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'offset10',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.offset10',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'rise11',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.rise11',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'offset11',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.offset11',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'rise12',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.rise12',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'offset12',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.offset12',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recorderId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.recorderId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recorder',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.recorder',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reviewerId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.reviewerId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reviewer',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.reviewer',
                sortable: true,
                isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            measureTimeRteFilter : '',
            measureTimeLteFilter : '',
            locationIdFilter : '',
            locationNameFilter : '',
            shiftIdFilter : '',
            shiftNameFilter : '',
            furnaceIdFilter : '',
            furnaceNameFilter : '',
            rise1Filter : '',
            offset1Filter : '',
            rise2Filter : '',
            offset2Filter : '',
            rise3Filter : '',
            offset3Filter : '',
            rise4Filter : '',
            offset4Filter : '',
            rise5Filter : '',
            offset5Filter : '',
            rise6Filter : '',
            offset6Filter : '',
            rise7Filter : '',
            offset7Filter : '',
            rise8Filter : '',
            offset8Filter : '',
            rise9Filter : '',
            offset9Filter : '',
            rise10Filter : '',
            offset10Filter : '',
            rise11Filter : '',
            offset11Filter : '',
            rise12Filter : '',
            offset12Filter : '',
            recorderIdFilter : '',
            recorderFilter : '',
            reviewerIdFilter : '',
            reviewerFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'measureTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.filter.measureTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'measureTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.filter.measureTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'shiftNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.filter.shiftName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstShift'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"shiftId":"id"}'
                        }
                },
                {
                key: 'furnaceNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.filter.furnaceName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'recorderFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.filter.recorder',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                        }
                },
                // {
                // key: 'reviewerFilter',
                // label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.filter.reviewer',
                // disabled: false,
                // form: {
                // type: 'entityModalSelect'
                //     ,entity: 'emAclUser'
                //     ,correspondingField: 'name'
                //     ,fieldsBindingByEntityModalSelected: '{"reviewerId":"id"}'
                //         }
                // }
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'measureTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.measureTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'shiftName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.shiftName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'imfMstShift'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"shiftId":"id"}'
                        }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.furnaceName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'rise1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.rise1',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'offset1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.offset1',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'rise2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.rise2',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'offset2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.offset2',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'rise3',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.rise3',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'offset3',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.offset3',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'rise4',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.rise4',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'offset4',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.offset4',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'rise5',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.rise5',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'offset5',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.offset5',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'rise6',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.rise6',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'offset6',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.offset6',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'rise7',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.rise7',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'offset7',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.offset7',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'rise8',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.rise8',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'offset8',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.offset8',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'rise9',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.rise9',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'offset9',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.offset9',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'rise10',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.rise10',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'offset10',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.offset10',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'rise11',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.rise11',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'offset11',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.offset11',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'rise12',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.rise12',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'offset12',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.offset12',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'recorder',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.recorder',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                        }
                },
                // {
                // key: 'reviewer',
                // label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.reviewer',
                // sortable: true,
                // disabled: false,
                // form: {
                // type: 'entityModalSelect'
                //     ,entity: 'emAclUser'
                //     ,correspondingField: 'name'
                //     ,fieldsBindingByEntityModalSelected: '{"reviewerId":"id"}'
                //         }
                // },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingFurnaceMeasure.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdSmeltingFurnaceMeasure, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        